import React, { useContext } from "react";
import PopupContext from "../../context/PopupContext";
import { getMessagePopupConfig } from "../../utils/messageResponse";
import "../../styles/components/MessagePopup.css";

function Icon({
  status,
  messageType,
  messageCode,
}: {
  status?: number;
  messageType?: string;
  messageCode?: string;
}) {
  const cfg = getMessagePopupConfig(messageType, messageCode, status);
  return <img className="gp-icon" src={cfg.icon} alt={cfg.iconAlt} />;
}

const GlobalPopup: React.FC = () => {
  const ctx = useContext(PopupContext);
  if (!ctx) return null;
  const { popupData, hidePopup } = ctx;

  if (!popupData.show) return null;

  const cfg = getMessagePopupConfig(
    popupData.messageType,
    popupData.messageCode,
    popupData.status,
  );
  const buttonLabel = popupData.status === 200 ? "OK" : "Cancel";

  const handleOk = () => {
    hidePopup();
    if (popupData.onOk) popupData.onOk();
  };

  return (
    <div className="gp-overlay">
      <div
        className={`gp-card ${cfg.accentClass}`}
        role="dialog"
        aria-modal="true"
      >
        <div className="gp-card-body d-flex">
          <div className="gp-icon-wrap">
            <Icon
              status={popupData.status}
              messageType={popupData.messageType}
              messageCode={popupData.messageCode}
            />
          </div>
          <div className="gp-content ms-3">
            <h5 className="gp-title">{cfg.title}</h5>
            <p className="gp-message mb-3">{popupData.message}</p>
            <div className="gp-footer text-center">
              <button
                type="button"
                className={`btn ${cfg.btnClass}`}
                onClick={handleOk}
              >
                {buttonLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalPopup;
